import React, {useEffect, useContext} from 'react';
import farmerContext from "../../../context/farmer/farmerContext";


const Wallet = () => {
    const FarmerContext = useContext(farmerContext);
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const {farmer, getFarms} = FarmerContext;


    useEffect(() => {

        //Get all farmers farms when the component mounts
        if (farmer.farms.length === 0) {
            getFarms();
        }

        //eslint-disable-next-line
    }, [farmer.farms]);

    return (

        <div class="content-wrapper">
            <div class="container-fluid">
                <h3 class="make-bold">Wallet</h3>
                <p>View Possible Request</p>

                <div class="dashboard-inner-view">
                    <div class="row mt-3">
                        <div class="col-lg-10 mx-auto">
                            <div class="main-content">
                                <div class="content-title-view">
                                    <div id="grad" class="content-title-view p-100">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col-lg-8">
                                                    <div class="media align-items-center">
                                                        <div class="avatar-holder-profile bord-radius-50 mx-auto">
                                                            <img src={userInfo.passport}
                                                                 class="img-fluid object-fit-cover object-pos-center h-100 w-100"
                                                                 alt="passport"/>
                                                        </div>
                                                        <div class="media-body">
                                                            <h3 class="mt-0">Hello, {userInfo.first_name}r</h3>
                                                            <p>{userInfo.email}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="amount-view overlap-content">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-10 mx-auto">
                                                <div class="card card-body bg-dark">
                                                    <div class="row align-items-center">
                                                        <div class="col-lg-6">
                                                            <p class="text-white mb-1">Wallet Balance</p>
                                                            <h2 class="text-white">$50,000</h2>
                                                        </div>
                                                        <div class="col-lg-4 offset-lg-2">
                                                            <div class="row align-items-center">
                                                                <div class="col-lg-6 mb-3">
                                                                    <a href="#"
                                                                       class="btn btn-orange btn-block">Credit</a>
                                                                </div>
                                                                <div class="col-lg-6 mb-3">
                                                                    <a href="transfer.php"
                                                                       class="btn btn-lemon-green text-dark btn-block">Withdraw</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="trans-his-sect my-4">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-10 mx-auto">
                                                <h3 class="my-3">Transaction History</h3>
                                                <div class="card card-body mb-3">
                                                    <div
                                                        class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="media">
                                                            <div class="profile-pix-50 bord-50 mr-3 border-2">
                                                                <img src="assets/images/credit.png"
                                                                     class="object-fit-cover object-pos-center h-100 w-100"
                                                                     alt="..."/>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0  text-success">$ 500,000</h5>
                                                                <p>Transaction Title</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>30 Jan, 2020 4:56pm</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card card-body mb-3">
                                                    <div
                                                        class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="media">
                                                            <div class="profile-pix-50 bord-radius-50 mr-3 border-2">
                                                                <img src="assets/images/debit.png"
                                                                     class="object-fit-cover object-pos-center h-100 w-100"
                                                                     alt="..."/>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0">$ 200,000</h5>
                                                                <p>Transaction Title</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>30 Jan, 2020 4:56pm</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card card-body mb-3">
                                                    <div
                                                        class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="media">
                                                            <div class="profile-pix-50 bord-50 mr-3 border-2">
                                                                <img src="assets/images/credit.png"
                                                                     class="object-fit-cover object-pos-center h-100 w-100"
                                                                     alt="..."/>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0 text-success">$ 500,000</h5>
                                                                <p>Transaction Title</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>30 Jan, 2020 4:56pm</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card card-body mb-3">
                                                    <div
                                                        class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="media">
                                                            <div class="profile-pix-50 bord-50 mr-3 border-2">
                                                                <img src="assets/images/debit.png"
                                                                     class="object-fit-cover object-pos-center h-100 w-100"
                                                                     alt="..."/>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0">$ 200,000</h5>
                                                                <p>Transaction Title</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>30 Jan, 2020 4:56pm</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card card-body mb-3">
                                                    <div
                                                        class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="media">
                                                            <div class="profile-pix-50 bord-50 mr-3 border-2">
                                                                <img src="assets/images/credit.png"
                                                                     class="object-fit-cover object-pos-center h-100 w-100"
                                                                     alt="..."/>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0 text-success">$ 500,000</h5>
                                                                <p>Transaction Title</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>30 Jan, 2020 4:56pm</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card card-body mb-3">
                                                    <div
                                                        class="d-flex justify-content-between align-items-center flex-wrap">
                                                        <div class="media">
                                                            <div class="profile-pix-50 bord-50 mr-3 border-2">
                                                                <img src="assets/images/debit.png"
                                                                     class="object-fit-cover object-pos-center h-100 w-100"
                                                                     alt="..."/>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0">$ 200,000</h5>
                                                                <p>Transaction Title</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>30 Jan, 2020 4:56pm</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default Wallet